import React from 'react';
import { Hero } from './components/Hero';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { TheProblem } from './components/TheProblem';
import { TheShift } from './components/TheShift';
import { TheMechanism } from './components/TheMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhatThisIsNot } from './components/WhatThisIsNot';
import { Objections } from './components/Objections';
import { ThePromise } from './components/ThePromise';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#FAF7F2] overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <WhoThisIsFor data-id="element-2" />
      <TheProblem data-id="element-3" />
      <TheShift data-id="element-4" />
      <TheMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhatThisIsNot data-id="element-7" />
      <Objections data-id="element-8" />
      <ThePromise data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}